import { FormControlLabel } from '@material-ui/core';
import * as React from 'react';
import * as ReactQuill from 'react-quill';
import { HashTagModel } from '../../../../models'
import { Views } from '../../../abstract';
import { Constants, ProjectViews } from '../../abstract';

interface IDashboardPostsAddEditViewProps extends Interfaces.IViewProps {
    onSearchHashTags: (s: string) => void
    hashTagsSearchResult: HashTagModel[]
    onSave: () => void
    onCreateNewTag: (s: string) => void
}

interface IDashboardPostsAddEditViewState extends Interfaces.IViewState {
    currentTextInSelect: string
}

class DashboardPostsAddEditView<P, S> extends ProjectViews.CommonView<P & IDashboardPostsAddEditViewProps, S & IDashboardPostsAddEditViewState> {

    constructor(props: any) {
        super(props);
    }

    public onDateChange(e?: any, v?: any) {
        const { model } = this.state;
        model['date'] = v ? v : null;
        this.setState({ model });
    }

    public onLanguageChange(v: string) {
        this.setState({ languageTabValue: v })
    }

    public onSelectHashTag(selectedTags: any) {
        this.clearErrorLabel();
        const { model } = this.state;
        model['selectedHashTags'] = selectedTags;
        this.setState({ model });
    }

    public validateForm() {
        const { onSave } = this.props;
        const { model } = this.state;
        if (model['title'].ru && model['title'].en) {
            if(model['keywords'].ru && model['keywords'].en){
                if (model['description'].ru && model['description'].en) {
                    if (model['image'].ru) {
                        if (model['image']['alt'].ru && model['image']['alt'].ru) {
                            if (model['selectedHashTags'].length) {
                                if (model['content'].ru && model['content'].en) {
                                    const ht: HashTagModel[] = [];
                                    model['selectedHashTags'].forEach((v: any) => {
                                        if (!v.value) {
                                            const newTag = new HashTagModel();
                                            newTag.popularity = 0;
                                            newTag.name = v.label;
                                            ht.push(newTag)
                                        }
                                    });
                                    model['unsavedHashTags'] = ht;
                                    onSave();
                                } else {
                                    this.setState({ error: 'Заполните тело новости на обоих языках!' })
                                }
                            } else {
                                this.setState({ error: 'Добавьте миниму один хэштег!' })
                            }
                        } else {
                            this.setState({ error: 'Заполните описание изображения на обоих языках!' })
                        }
                    } else {
                        this.setState({ error: 'Загрузите изображение для русского языка!' })
                    }
                } else {
                    this.setState({ error: 'Заполните описание на обоих языках!' })
                }
            } else {
                this.setState({ error: 'Заполните мета ключевые слова на обоих языках!' })
            }
        } else {
            this.setState({ error: 'Заполните заголовок на обоих языках!' })
        }
    }

    public onSelectTextChange(s: string) {
        const { onSearchHashTags } = this.props;
        this.setState({ currentTextInSelect: s });
        onSearchHashTags(s);
    }

    public async onCreateNewTag() {
        const { currentTextInSelect, model } = this.state;
        const { onCreateNewTag } = this.props;
        let exist = false;
        model['selectedHashTags'].forEach((h: any) => {
            if (h.label === currentTextInSelect) {
                exist = true;
            }
        })
        if (!exist) {
            const newHashTag = await onCreateNewTag(currentTextInSelect);
            const prev = model['selectedHashTags']
            model['selectedHashTags'] = []
            this.setState({ model });
            model['selectedHashTags'] = prev
            model['selectedHashTags'].push({ label: newHashTag['name'], value: newHashTag['id'] });
            this.setState({ model });
        }
    }

    public renderLeftSide(): JSX.Element {
        const { hashTagsSearchResult } = this.props;
        const { languageTabValue, model } = this.state;
        return (
            <React.Fragment>
                <Views.TextField
                    floatingLabelText="Заголовок"
                    fullWidth={true}
                    name="title"
                    value={model['title'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Описание (не более 250 символов)"
                    fullWidth={true}
                    multiLine={true}
                    maxlength="250"
                    name="description"
                    value={model['description'] && model['description'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                < Views.TextField
                    name="video url"
                    floatingLabelText="Ссылка на видео"
                    fullWidth={true}
                    value={model['video']['url'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Мета-описание видео"
                    fullWidth={true}
                    name="video alt"
                    value={model['video']['alt'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Мета ключевые слова"
                    fullWidth={true}
                    multiLine={true}
                    name="keywords"
                    value={model['keywords'] && model['keywords'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.Dropzone
                    file={model['image'][languageTabValue]}
                    onDrop={(files: any) => this.onDropImage(files)}
                    multiple={false}
                    onClear={() => this.onDropImage()}
                    accept="image/*"
                />
                <Views.TextField
                    floatingLabelText="Мета-описание изображения"
                    fullWidth={true}
                    name="image alt"
                    value={model['image']['alt'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.DatePicker
                    name="date"
                    value={model['date']}
                    onChange={(e, v) => this.onDateChange(e, v)}
                    onClear={() => this.onDateChange()}
                />
                <Views.Select
                    name="select"
                    multi={true}
                    placeholder="Хэштеги"
                    onInputChange={(s) => this.onSelectTextChange(s)}
                    onChange={(o: any) => this.onSelectHashTag(o)}
                    onNewTag={() => this.onCreateNewTag()}
                    options={hashTagsSearchResult.map(e => ({ label: e.name, value: e.id }))}
                    value={model['selectedHashTags']}
                />
            </React.Fragment>
        )
    }

    public renderRightSide(): JSX.Element {
        const { model, languageTabValue } = this.state
        return (
            <React.Fragment>
                <FormControlLabel
                    style={{ alignSelf: 'flex-start' }}
                    control={
                        <Views.Switch
                            checked={model['published']}
                            onChange={(e, c) => { model['published'] = c; this.setState({ model }) }}
                            color="black"
                        />
                    }
                    label="Опубликовано"
                />
                <ReactQuill
                    modules={{
                        syntax: true,
                        clipboard: {
                            matchVisual: false,
                        },
                        toolbar: Constants.QuillEditorConstants.toolbarOptions
                    }}
                    onChange={(v) => this.onTextChange(v, 'content')}
                    className="editor-view"
                    value={model['content'][languageTabValue] || ''}
                />
                <Views.Dropzone
                    file={model['metaImages']?model['metaImages']['fb']:null}
                    onDrop={(files: any) => this.onDropImage(files, 'metaImages fb')}
                    multiple={false}
                    onClear={() => this.onDropImage(null,'metaImages fb')}
                    placeholder="для meta Facebook и Twitter"
                    accept="image/*"
                />
                <Views.Dropzone
                    file={model['metaImages']?model['metaImages']['vk']:null}
                    onDrop={(files: any) => this.onDropImage(files, 'metaImages vk')}
                    multiple={false}
                    onClear={() => this.onDropImage(null,'metaImages vk')}
                    placeholder="для meta Vk"
                    accept="image/*"
                />
            </React.Fragment>
        )
    }
}

export default DashboardPostsAddEditView;



// WEBPACK FOOTER //
// ./src/app/dashboard/posts/addedit/DashboardPostsAddEditView.tsx